import styled from '@emotion/styled';
import { css } from '@emotion/core';
import ReactFlowBase from 'reactflow';
import { STEP_CARD_WIDTH } from '../Steps/constants';

import _Merged from './images/merged.svg?react';
import _SplitUnmerged from './images/split-unmerged.svg?react';
import _SplitMerged from './images/split-merged.svg?react';

// custom styles
export const ReactFlow = styled(ReactFlowBase)`
  .react-flow__node,
  .react-flow__handle.connectable {
    cursor: initial;
    min-width: unset;
    min-height: unset;
  }
`;

// Fixed-size box a step card is laid out in (see getStaticNodeDimensions in layout.ts).
// It fills the react-flow node, whose height is set by the layout.
// The card is vertically centered, so its handles are always at the slot's center no
// matter how tall the card is. A card taller than the slot overflows evenly on both sides.
export const StepSlot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${STEP_CARD_WIDTH}px;
  height: 100%;
  pointer-events: none;
  > * {
    pointer-events: auto;
  }
`;

export const MergeWrapper = styled.div`
  height: 44px;
  width: 44px;
  position: relative;

  > svg {
    transform: translate(-3px, -2px);
  }
  div.refresh-wrapper {
    width: 200px;
    position: relative;
    left: ${-(200 - 44) / 2}px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div.refresh-button {
    width: fit-content;
    background: var(--color-background-white);
    border-radius: 8px;
    button {
      box-shadow: 0 4px 7px
        color-mix(in srgb, var(--color-background-black) 50%, transparent) !important;
    }
  }
`;

export const Merged = styled(_Merged, {
  shouldForwardProp: (prop) => !['statusColor', 'isSelected'].includes(prop),
})<{ statusColor?: string; isSelected?: boolean }>`
  ${({ statusColor, isSelected }) =>
    statusColor
      ? css`
          .fill {
            fill: ${statusColor};
            ${
              isSelected
                ? css`
                    filter: drop-shadow(
                      0px 3px 3px
                        color-mix(
                          in srgb,
                          var(--color-background-black) 50%,
                          transparent
                        )
                    );
                  `
                : null
            }
} 
          }
        `
      : null}
`;

export const SplitUnmerged = styled(_SplitUnmerged, {
  shouldForwardProp: (prop) => prop !== 'isBlank',
})<{ isBlank?: boolean }>`
  ${({ isBlank }) =>
    isBlank
      ? css`
          .stroke {
            stroke: #fff;
          }
        `
      : css`
          :hover {
            .stroke {
              stroke: #216ff7;
            }
            .fill {
              fill: #216ff7;
            }
          }
        `}
`;
export const SplitMerged = styled(_SplitMerged, {
  shouldForwardProp: (prop) => prop !== 'isBlank',
})<{ isBlank?: boolean }>`
  ${({ isBlank }) =>
    isBlank
      ? css`
          .fill {
            fill: var(--color-background-white);
          }
        `
      : css`
          :hover {
            .fill {
              fill: var(--color-button-secondary-hover);
            }
          }
        `}
`;
